import { useReceiptStore } from "@elixir/stores";

export const makeReceiptOnLocal = () => {
  const forceServerGeneration =
    useReceiptStore.getState()?.forceServerReceiptGeneration;

  return !forceServerGeneration;
};
